import bafLogo from '@/assets/baf_logo_no_shadow.png'
import { useTranslation } from 'react-i18next'

export default function Footer() {
  const { t } = useTranslation()
  return (
    <div id='footer' className='bg-slate-100 text-neutral-900 text-center py-8 flex flex-row justify-center'>
      <div className='text-sm flex flex-col justify-center space-y-4'>
        <a className='hover:underline hover:cursor-pointer' href={'https://booksarefun.com/'} target='_blank'>
          <div className='inline'>
            <div className='w-36 mx-auto -ml-2'>
              <img src={bafLogo} className='object-contain' alt='Books Are Fun Logo' />
              <span className='text-xs ml-4'>booksarefun.com</span>
            </div>
          </div>
        </a>

        <div className='flex flex-col'>
          <a
            className='hover:underline hover:cursor-pointer inline-block w-24 mx-auto'
            href={t('business.privacy_url')}
            target='_blank'
          >
            Privacy Policy
          </a>
          <a
            className='hover:underline hover:cursor-pointer inline-block'
            href={'https://booksarefun.com/terms-and-conditions'}
            target='_blank'
          >
            Terms of Use
          </a>
          <a
            className='hover:underline hover:cursor-pointer inline-block'
            href={'https://app.booksarefun.com/support'}
            target='_blank'
          >
            Support
          </a>
        </div>
        <div>© {t('business.name')}</div>
      </div>
    </div>
  )
}
